"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutlinedIcon = OutlinedIcon;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("./Icon");
function OutlinedIcon({ icon, ...rest }) {
    return react_1.default.createElement(Icon_1.Icon, { icon: icon, filled: false, ...rest });
}
